export default __webpack_public_path__ + "static/media/Endscenario-1.e7a3b652.png";